































import './assets/css/custom.css';
import { Hub, Auth, Logger } from 'aws-amplify';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ConcussionClinic from './components/ConcussionClinic.vue';
import UserInfo from './components/UserInfo.vue';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';

@Component({
  components: {
    ConcussionClinic,
    UserInfo,
  },
})
export default class App extends Vue {
  private drawer: boolean = false;

  private pages = [
    {
      path: '/concussion-clinic',
      title: 'Concussion Clinic - A&P',
    },
    {
      path: '/concussion-exam',
      title: 'Concussion Clinic - Exam',
    },
    {
      path: '/dementia-quality-care-metrics',
      title: 'Dementia - Quality Care Metrics',
    },
  ];

  @Prop()
  private source!: string;

  public signedIn: boolean = false;
  public username: string = '';
  public onAuthPage: boolean = false;

  public created() {
    this.updateCurrentUserState();
    this.listenForAuthPageChanges();
    this.listenForAuthEvents();
  }

  private listenForAuthPageChanges() {
    this.onAuthPage = this.$router.currentRoute.name === 'auth';
    this.$router.afterEach((to, from) => {
      this.onAuthPage = to.name === 'auth';
      this.checkAuthRedirect();
    });
  }

  private listenForAuthEvents() {
    Hub.listen('auth', (data) => {
      const handlers: { [k: string]: () => void } = {
        signIn: this.updateCurrentUserState,
        signOut: () => {
          this.userStateChange(null);
        },
      };
      if (handlers.hasOwnProperty(data.payload.event)) {
        handlers[data.payload.event]();
      }
    });
  }

  private updateCurrentUserState() {
    Auth.currentAuthenticatedUser()
      .then((authData) => {
        this.userStateChange(authData);
      })
      .catch((err) => {
        this.userStateChange(null);
      });
  }

  private userStateChange(authData: any) {
    this.signedIn = authData ? true : false;
    if (authData) {
      this.username = authData.username;
    }
    this.$root.$data.signedIn = this.signedIn;
    this.checkAuthRedirect();
  }

  private checkAuthRedirect() {
    if (this.signedIn) {
      if (this.onAuthPage) {
        this.$router.push('/');
      }
    }
  }

  public beforeDestroy() {
    return onAuthUIStateChange;
  }
}
